module.exports = __webpack_public_path__ + "img/s4Model1.ea423783.webp";